module.exports = __webpack_public_path__ + "img/bootstrap4-dark-blue.4d4353e1.svg";